export const appEvents = {
  onVisibilityHidden: null as (() => void) | null,

  onVisibilityChange: null as ((isVisible: boolean) => void) | null,
};
